<template>
  <div class="design">
    <headd :mobile_title="mobile_title"></headd>
    <div class="banner">
      <img src="../../static/logo/bannerpay.jpg" />
    </div>
    <div class="formbox container">

      <div class="re_title">LOGO设计服务</div>
      <div class="re_input">
        <div class="icon">￥</div>
        {{ price }}
      </div>

      <div class="box_title">填写信息</div>
      <div class="dbox_cell">
        <div class="dbox_name">姓名</div>
        <div class="dbox_input">
          <input
            type="text"
            v-model="formdata.name"
            placeholder="请输入姓名"
            class="input"
          />
        </div>
      </div>
      <div class="dbox_cell">
        <div class="dbox_name">手机号码</div>
        <div class="dbox_input">
          <input
            type="text"
            v-model="formdata.tel"
            placeholder="请输入手机号"
            class="input"
            maxlength="11"
          />
        </div>
      </div>
      <div class="dbox_cell">
        <div class="dbox_name">需求描述</div>
        <div class="dbox_input">
          <textarea
            class="textarea"
            v-model="formdata.service"
            placeholder="请输入"
          ></textarea>
        </div>
      </div>
      <div class="dbox_cell">
        <div class="dbox_name">设计师</div>
        <div class="dbox_input">
          <div class="select">
            <select v-model="designSelected" @change="getdesignSelected($event)"
              ><option v-for="item in designerSelect">{{
                item.name
              }}</option></select
            >
          </div>
        </div>
      </div>

      <div class="info">
        <div class="name">请选择支付方式</div>
        <div class="pay_type">
          <div
            class="type_item"
            v-for="(item, index) in items"
            :key="item.value"
          >
            <div class="type_name">
              <div class="type_icon">
                <img :src="'../../static/order/pay_' + item.value + '.png'" />
              </div>
              {{ item.name }}
            </div>
            <div>
              <input
                class="radio"
                type="radio"
                id="type"
                :value="item.value"
                :checked="index === current"
                v-model="paytype"
              />
            </div>
          </div>
        </div>
      </div>

      <div class="btn_save" @click="payorder">立即购买</div>
    </div>
    <div class="designlist container">
      <div class="d_title">
        <div class="dt_icon"></div>
        设计师介绍
      </div>
      <div class="dt_item" v-for="item in designerList" :key="item.id">
        <div class="item_info">
          <img :src="item.avatarUrl" class="avtar" />
          <div class="i_info">
            <div class="i_name">
              {{ item.name }} | <span>{{ item.title }}</span>
            </div>
            <div class="i_jinli">工作经验{{ item.workyears }}年</div>
          </div>
        </div>
        <div class="item_tag">
          <div class="i_tag" v-for="item2 in item.service_advantage">
            {{ item2 }}
          </div>
        </div>
        <div class="item_intro">
          <div class="t">个人介绍：</div>
          {{ item.work_desc }}
        </div>
      </div>
    </div>
    <el-dialog
      :visible.sync="dialogFormVisible"
      width="6rem"
      :before-close="handleClose"
    >
      <div class="code_con">
        <div class="qr_tip">
          <span>使用微信扫码支付</span>
        </div>
        <div id="qrCode" ref="qrCodeDiv"></div>
        <div class="qr_btn" @click="qr_btn">完成</div>
      </div>
    </el-dialog>
    <foot></foot>
  </div>
</template>

<script>
import headd from "../components/head";
import foot from "@/components/foot";
import { getlogodesign, getdesigner,getbuylogopage ,getlogopayment} from "./api/api"; //引入api里面定义的方法
import QRCode from "qrcodejs2";
export default {
  data() {
    return {
      price: "",
      items: [
        {
          value: "1",
          name: "支付宝"
        },
        {
          value: "2",
          name: "微信"
        }
      ],
      type: ["alipay", "wxpcpay"],
      current: 0,
      paytype: "1",
      dialogFormVisible: false,
      mobile: false,
      dialogFormVisible_2: false,
      mobile_title: "设计logo",

      designerList: [],
      designerSelect: [],
      designSelected: "请选择",
      formdata: {
        name: "",
        tel: "",
        service: "",
        designer: "",
        designerid: 0
      },
      index: 0
    };
  },
  metaInfo: {
    title: "马上创业网 专注企业注册的网站", // set a title
    meta: [
      {
        // set meta
        name: "keyWords",
        content:
          "马上创业网，注册公司，代理记账，上海注册公司，注册公司流程，注册公司费用，商标注册，法务咨询，法律服务，个体工商户注册，许可证办理，专业法律，社保，公积金，专利申请，医疗器械许可证，ICP电信增值许可证，食品经营许可证，酒类经营许可证，餐饮服务许可证，道路运输许可证，广播电视节目许可证，海关资质，进出口许可证，商标设计，logo设计，VI设计，海报设计，包装设计，APP开发，微信运营，网站定制，版权服务，软件著作权，发明专利，外观设计专利，实用新型专利，商标转让，驳回复审，注销公司，股权变更，经营范围变更，股权协议，股权转让，劳务派遣"
      },
      {
        name: "description",
        content:
          "马上创业网是一个专为中小企业服务的综合平台，主要提供医疗器械服务、审计服务、知识产权服务、财税咨询、注册公司、代理记账、商标注册、专利申请、社保代理、法务代理等一站式的服务，借助移动互联网技术，改善并升级企业服务状态，实现了新形势下中小企业所需要的企业服务。"
      }
    ]
  },
  components: {
    headd,
    foot
  },
  mounted() {
    this.getdesigner();
    this.buylogoPageData();
    if (this.isWeiXin()) {
      this.items = [
        {
          value: "2",
          name: "微信"
        }
      ];
      this.paytype = "2";
      this.mobile = true;
    } else {
      this.items = [
        {
          value: "1",
          name: "支付宝"
        },
        {
          value: "2",
          name: "微信"
        }
      ];
      this.paytype = "1";
      this.mobile = false;
    }
  },
  methods: {

    //判断是否是微信浏览器的函数
    isWeiXin() {
      //window.navigator.userAgent属性包含了浏览器类型、版本、操作系统类型、浏览器引擎类型等信息，这个属性可以用来判断浏览器类型
      var ua = window.navigator.userAgent.toLowerCase();
      //alert(JSON.stringify(ua));
      //通过正则表达式匹配ua中是否含有MicroMessenger字符串
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        return true;
      } else {
        return false;
      }
    },
    handleClose() {
      console.log(123);
      this.dialogFormVisible = false;
      document.getElementById("qrCode").innerHTML = "";
    },
    qr_btn() {
      console.log(123);
      this.dialogFormVisible = false;
      document.getElementById("qrCode").innerHTML = "";
    },
    cancle() {
      this.isread = false;
      this.dialogFormVisible_2 = false;
    },
    comfir() {
      this.isread = true;
      this.dialogFormVisible_2 = false;
      this.payorder();
    },
    async buylogoPageData() {
      var _self = this;
      const res = await getbuylogopage();
      var data = res.data.data;
      //console.log(data)
      
      _self.price = data.price;
    },
    radioChange: function(evt) {
      for (let i = 0; i < this.items.length; i++) {
        if (this.items[i].value === evt.target.value) {
          console.log(i);
          this.current = i;
          break;
        }
      }
    },
    gorecharge(e) {
      var that = this;
      that.recharge_price = e.detail.value;
    },

    payorder() {
      var _self = this;

      var data = _self.formdata;
      console.log(data);
      var phone_reg = /^1[3456789]\d{9}$/;
      if (data.name == "") {
        this.$toast("请输入名字");

        return false;
      }
      if (data.tel == "") {
        this.$toast("请输入电话");

        return false;
      } else {
        if (!phone_reg.test(data.tel)) {
          this.$toast("手机号码格式错误");

          return false;
        }
      }
      if (data.service == "") {
        this.$toast("请输入需求描述");

        return false;
      }

      if (data.designer == "") {
        this.$toast("请选择设计师");
        return false;
      }

    
      if (_self.type[_self.paytype - 1] == "alipay") {
        var parm = [
          {
            name: "uid",
            value: localStorage.getItem("userId")
          },

          {
            name: "pay_type",
            value: "alipay"
          },
          {
            name: "sessionToken",
            value: localStorage.getItem("sessionToken")
          },
          {
            name: "tel",
            value: data.tel
          },
          {
            name: "name",
            value: data.name
          },
          {
            name: "service",
            value: data.service
          },
          {
            name: "designer",
            value: data.designer
          },
          {
            name: "designerid",
            value: data.designerid
          }


        ];
        //模拟form表单
        var temp_form = document.createElement("form");
        temp_form.action =
          "https://mscyeserver.mscye.com/web.php/webapi/logopayment";
        //如需打开新窗口，form的target属性要设置为'_blank'
        temp_form.target = "_self";
        temp_form.method = "post";
        temp_form.style.display = "none";
        //添加参数
        for (var item in parm) {
          var opt = document.createElement("textarea");
          //console.log(parm[item].name);
          opt.name = parm[item].name;
          opt.value = parm[item].value;
          temp_form.appendChild(opt);
        }
        document.body.appendChild(temp_form);
        //提交数据
        temp_form.submit();
      } else if (_self.type[_self.paytype - 1] == "wxpcpay") {
        // var parm = {
        //   uid: localStorage.getItem("userId"),
        //   pay_type: "wxpcpay"
        // };
        // _self.pay_weixin(parm);

        if (_self.mobile) {
          var parm = {
            uid: localStorage.getItem("userId"),
            openid: localStorage.getItem("openid"),
            pay_type: "wxjspay",
            tel: data.tel,
            name: data.name,
            service: data.service,
            designer: data.designer,
            designerid: data.designerid
          };
          _self.pay_weixin_mobile(parm);
        } else {
          var parm = {
            uid: localStorage.getItem("userId"),
            pay_type: "wxpcpay",
            tel: data.tel,
            name: data.name,
            service: data.service,
            designer: data.designer,
            designerid: data.designerid
          };
          _self.pay_weixin(parm);
        }
      }
    },
    async pay_weixin(parm) {
      var _self = this;
      const res = await getlogopayment(parm);
      console.log(JSON.parse(res.data.payStr).code_url);
      _self.dialogFormVisible = true;
      _self.$nextTick(function() {
        var qrcode = new QRCode(this.$refs.qrCodeDiv, {
          text: JSON.parse(res.data.payStr).code_url,
          width: 200,
          height: 200,
          colorDark: "#000000",
          colorLight: "#ffffff",
          correctLevel: QRCode.CorrectLevel.H
        });
      });
    },
    async pay_weixin_mobile(parm) {
      var _self = this;
      const res = await getlogopayment(parm);
      var data = JSON.parse(res.data.payStr);
      if (typeof WeixinJSBridge == "undefined") {
        if (document.addEventListener) {
          document.addEventListener(
            "WeixinJSBridgeReady",
            onBridgeReady,
            false
          );
        } else if (document.attachEvent) {
          document.attachEvent("WeixinJSBridgeReady", onBridgeReady);
          document.attachEvent("onWeixinJSBridgeReady", onBridgeReady);
        }
      } else {
        _self.onBridgeReady(data);
      }
    },
    onBridgeReady(data) {
      WeixinJSBridge.invoke(
        "getBrandWCPayRequest",
        {
          appId: "" + data.appId,
          timeStamp: "" + data.timeStamp,
          nonceStr: "" + data.nonceStr,
          package: "" + data.package,
          signType: "" + data.signType,
          paySign: "" + data.paySign
        },
        function(res) {
          console.log(res);
          if (res.err_msg == "get_brand_wcpay_request:ok") {
            this.$router.push({
              path: "/"
            });
            // 使用以上方式判断前端返回,微信团队郑重提示：
            //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
          }
        }
      );
    },
    async pay(parm) {
      console.log(parm);
      var _self = this;
      const res = await this.$myRuquest({
        url: "/logopayment",
        data: parm,
        method: "POST"
      });
      console.log(res);

      if (res.data.status == 1) {
        console.log(_self.type[_self.current]);
        if (_self.type[_self.current] == "alipay") {
          console.log("alipay");
          uni.requestPayment({
            provider: "alipay", //服务提供商（支付宝）（服务提供商，通过uni.getProvider获取）
            orderInfo: res.data.data.payStr, //后台返回的支付宝订单数据
            success(res) {
              console.log("success:" + JSON.stringify(res));
              return uni.showToast({
                title: "支付成功",
                complete: function(res) {
                  uni.switchTab({
                    url: "/pages/index/index"
                  });
                }
              });
            },
            fail(err) {
              uni.showModal({
                title: "支付失败"
              });
              console.log("fail:" + JSON.stringify(err));
            }
          });
        } else if (_self.type[_self.current] == "wxpay") {
          console.log("wxpay");
          //console.log(ordernfo)
          uni.requestPayment({
            provider: "wxpay", //服务提供商（微信）（服务提供商，通过uni.getProvider获取）
            orderInfo: JSON.parse(res.data.data.payStr), //后台返回的微信订单数据
            success(res) {
              console.log("success:" + JSON.stringify(res));
              return uni.showToast({
                title: "支付成功",
                complete: function(res) {
                  uni.switchTab({
                    url: "/pages/index/index"
                  });
                }
              });
            },
            fail(err) {
              uni.showModal({
                title: "支付失败"
              });
              console.log("fail:" + JSON.stringify(err));
            }
          });
        }
      }
    },
    async getdesigner() {
      var _self = this;
      const res = await getdesigner();
      //console.log(res.data);
      _self.designerList = res.data.data.designer;
      _self.designerSelect = [
        {
          value: "请选择",
          name: "请选择"
        },
        ...res.data.data.designer
      ];
    },

    getdesignSelected(e) {
      var _self = this;
      //console.log(e.target.selectedIndex);
      //console.log(_self.designerSelect[1]);
      //_self.formdata.designer = e.target.value;
      if (parseInt(e.target.selectedIndex) > 0) {
        _self.formdata.designer =
          _self.designerSelect[e.target.selectedIndex].name;
        _self.formdata.designerid =
          _self.designerSelect[e.target.selectedIndex].id;
      }
    },
    async btn_save() {
      var _self = this;
      var data = _self.formdata;
      console.log(data);
      var phone_reg = /^1[3456789]\d{9}$/;
      if (data.name == "") {
        this.$toast("请输入名字");

        return false;
      }
      if (data.tel == "") {
        this.$toast("请输入电话");

        return false;
      } else {
        if (!phone_reg.test(data.tel)) {
          this.$toast("手机号码格式错误");

          return false;
        }
      }
      if (data.service == "") {
        this.$toast("请输入需求描述");

        return false;
      }

      if (data.designer == "") {
        this.$toast("请选择设计师");
        return false;
      }

      var parm = {
        uid: localStorage.getItem("userId"),
        tel: data.tel,
        name: data.name,
        service: data.service,
        designer: data.designer,
        designerid: data.designerid
      };

      const res = await getlogodesign(parm);
      if (res.status == 1) {
        this.$toast({
          message: "提交成功",
          type: "success"
        });
        _self.formdata = {};
        _self.index = 0;
        _self.designSelected = "请选择";
      }
    }
  },
  beforeCreate: function() {
    document.getElementsByTagName("body")[0].className = "body_back";
  },
  beforeDestroy: function() {
    document.body.removeAttribute("class", "body_back");
  }
};
</script>

<style lang="less" scoped>
page {
  background-color: #f2f2f2;
}
.body_back {
  @media (max-width: 991px) {
    background: #f2f2f2;
  }
}
.formbox {
  width: 8rem;
  margin: auto;
  @media (max-width: 991px) {
    margin: 0.3rem 0.32rem;
    width: 6.86rem;
    padding: 0.4rem !important;
    height: auto;
    background: #ffffff;
    box-shadow: 0 0.04rem 0.14rem 0 rgba(0, 0, 0, 0.08);
    border-radius: 0.2rem;
    flex-direction: column;
  }

.re_title {
    font-size: 0.24rem;
    color: #8d8e99;
    padding: 0 0.32rem;
    margin-bottom: 0.1rem;
    @media (max-width: 991px) {
      font-size: 0.32rem;
    }
  }

  .re_input {
    // border-bottom: 0.01rem solid #ccc;
    align-items: center;
    padding: 0.23rem 0.32rem;
    font-size: 0.5rem;
    line-height: 0.5rem;
    color: #ff545a;
    display: flex;
    justify-content: center;
    .icon {
      font-size: 0.3rem;
      margin-right: 0.1rem;
    }
  }

  .info {
    flex-direction: column;
    width: ~"calc(100% - 64rpx)";
    padding: 0.3rem 0.32rem;
    // border-bottom: 1rpx solid rgba(196, 196, 204, 0.5);

    .name {
      font-size: 0.26rem;
      color: #1b1c33;
      line-height: 0.42rem;
      margin-bottom: 0.24rem;
      margin-top: 0.2rem;
      @media (max-width: 991px) {
        font-size: 0.32rem;
      }
    }

    .option {
      flex-direction: row;
      margin-bottom: 20rpx;

      .title {
        font-size: 26rpx;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #1b1c33;
        line-height: 37rpx;
        width: 130rpx;
      }

      .content {
        width: 500rpx;
        flex-direction: column;
        font-size: 26rpx;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #444649;
        line-height: 37rpx;

        view {
          margin-bottom: 15rpx;
          flex-direction: row;

          &:last-child {
            margin-bottom: 0;
          }

          .red {
            color: rgba(255, 84, 90, 1);
          }

          .status {
            margin-left: 32rpx;
            font-weight: 600;
            color: #1395ff;
          }
        }
      }

      &:last-child {
        margin-bottom: 0;
      }
    }

    .price {
      margin-top: 21rpx;
      font-size: 30rpx;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 600;
      color: #1b1c33;
      line-height: 42rpx;
      letter-spacing: 1rpx;

      .span {
        color: #ff545a;
      }
    }

    .pay_type {
      width: 4rem;
      margin: auto;

      radio-group {
        width: 100%;
      }

      .type_item {
        justify-content: space-between;
        width: 100%;
        align-items: center;
        margin-bottom: 0.4rem;
        display: flex;

        .type_name {
          font-size: 0.24rem;

          color: #1b1c33;
          display: flex;

          .type_icon {
            width: 0.36rem;
            height: 0.36rem;
            margin-right: 0.2rem;

            img {
              width: 100%;
              height: 100%;
            }
          }
          @media (max-width: 991px) {
            font-size: 0.28rem;
          }
        }
        .radio {
          width: 0.2rem;
          height: 0.2rem;
          @media (max-width: 991px) {
            width: 0.28rem;
            height: 0.28rem;
          }
        }
      }
    }

    .btn_list {
      width: 100%;
      justify-content: space-between;
      margin-top: 20rpx;

      .btn {
        width: 4.94rem;
        height: 0.7rem;
        font-size: 0.24rem;
        color: #ffffff;
        line-height: 0.7rem;
        text-align: center;
        justify-content: center;
        align-items: center;
        @media (max-width: 991px) {
          font-size: 0.28rem;
        }
      }

      .btn.kefu {
        background: url(../../static/order/btn_1.png) no-repeat;
        background-size: 309rpx 80rpx;
      }

      .btn.buy {
        background: #ff545a;
      }
    }
  }
  


}
.design {
  flex-direction: column;
  .banner {
    img {
      width: 100%;
      height: 360rpx;
    }
  }

  .designlist {
    width: 8rem;
    margin: 0 auto;
    flex-direction: column;
    display: flex;
    text-align: left;
    @media (max-width: 991px) {
      width: 6.86rem;
      padding: 0;
    }
    .d_title {
      width: 100%;
      align-items: center;
      margin-bottom: 0.4rem;
      display: flex;
      .dt_icon {
        width: 0.05rem;
        height: 0.26rem;
        background: #1395ff;
        border-radius: 0.03rem;
        margin-right: 0.1rem;
      }
      font-size: 0.26rem;
      color: #1b1c33;
      line-height: 0.37rem;
    }
    .dt_item {
      width: 100%;
      background: #ffffff;
      border-radius: 0rem;
      padding: 0.2rem 0.4rem;
      flex-direction: column;
      margin-bottom: 0.4rem;
      display: flex;
      border-bottom: 0.01rem solid #ccc;
      @media (max-width: 991px) {
        padding: 0.2rem 0.2rem;
      }
      .item_info {
        align-items: center;
        margin-bottom: 0.23rem;
        display: flex;
        .avtar {
          width: 1.26rem;
          height: 1.26rem;
          margin-right: 0.3rem;
          border-radius: 50%;
          background-color: #f2f2f2;
        }
        .i_info {
          flex-direction: column;
          .i_name {
            height: 0.37rem;
            font-size: 0.26rem;
            font-weight: bolder;
            color: #1b1c33;
            line-height: 0.37rem;
            margin-bottom: 0.15rem;
            span {
              font-size: 0.2rem;
            }
            @media (max-width: 991px) {
              font-size: 0.3rem;
              line-height: 0.37rem;
            }
          }
          .i_jinli {
            height: 0.28rem;
            font-size: 0.2rem;
            color: #1b1c33;
            line-height: 0.28rem;
            @media (max-width: 991px) {
              font-size: 0.28rem;
              line-height: 0.33rem;
            }
          }
        }
      }
      .item_tag {
        flex-wrap: wrap;
        justify-content: flex-start;
        margin-bottom: 0.12rem;
        display: flex;
        .i_tag {
          padding: 0 0.15rem;
          height: 0.33rem;
          background: rgba(19, 149, 255, 0.07);
          border-radius: 0.17rem;
          font-size: 0.2rem;
          color: #1395ff;
          margin-right: 0.2rem;
          margin-bottom: 0.2rem;
          @media (max-width: 991px) {
            font-size: 0.26rem;
          }
        }
      }
      .item_intro {
        display: flex;
        .t {
          font-size: 0.24rem;
          font-weight: bolder;
          width: 1.4rem;
          @media (max-width: 991px) {
            width: 3rem;
            font-size: 0.28rem;
          }
        }
        width: 100%;
        font-size: 0.18rem;
        line-height: 0.25rem;
        @media (max-width: 991px) {
          font-size: 0.28rem;
          line-height: 0.33rem;
        }
      }
    }
  }
}
.btn_save {
  margin: 0.5rem auto 0.5rem auto;
  width: 4.94rem;
  height: 0.7rem;
  line-height: 0.7rem;
  background: #ff545a;
  border-radius: 0.35rem;
  font-size: 0.24rem;
  text-align: center;
  color: #ffffff;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.box_title {
  @media (max-width: 991px) {
    font-size: 0.38rem;
    line-height: 0.38rem;
    margin-bottom: 0.4rem;
  }
}

.code_con {
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  .qr_tip {
    font-size: 0.16rem;
    line-height: 0.25rem;
    text-align: center;
    @media (max-width: 991px) {
      font-size: 0.28rem;
      line-height: 0.33rem;
    }
  }
  .qr_btn {
    margin-top: 0.2rem;
    width: 1.26rem;
    height: 0.4rem;
    font-size: 0.24rem;
    line-height: 0.4rem;
    background-color: #1395ff;
    border-radius: 0.2rem;
    color: #ffffff;
    text-align: center;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    cursor: pointer;
    @media (max-width: 991px) {
      font-size: 0.28rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/designlogo_pay.vue